import * as React from "react";
import { cn } from "../lib";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, startIcon, endIcon, ...props }, ref) => {
    return (
      <div
        className={cn(
          "flex h-11 items-center gap-2 rounded-xl bg-[#EBEDF9] px-3 text-sm text-gray-20",
          className,
        )}
      >
        {startIcon}
        <input
          ref={ref}
          className="w-full bg-transparent text-gray-30 placeholder:text-gray-20 focus:outline-none"
          {...props}
        />
        {endIcon}
      </div>
    );
  },
);

Input.displayName = "Input";

export { Input };
